const Promise = require("es6-promise");

/**
 * Debounces/throttles a function
 *
 * @param timeout
 * @param callback
 * @returns {debounced}
 */
function debounce(timeout, callback) {
	let timer;
	let debounced = function () {
		let args = arguments;

		debounced.cancel();

		timer = setTimeout(() => {
			timer = null;
			callback.apply(this, args);

		}, timeout);
	};

	debounced.cancel = function () {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
	};

	debounced.run = function () {
		debounced.cancel();
		callback.apply(this, arguments);
	};

	return debounced;
}

/**
 * Creates a promise throttling
 * @param amount
 * @returns {function(*=)}
 */
function createPromiseThrottle(amount, then) {
	let promise;
	let resolve;
	let reject;

	const resolver = debounce(amount, (...args) => {
		if (promise) {
			promise = null;
			resolve(...args);
		}
	});

	const throttle = (...args) => {
		if (promise) {
			promise = null;
			reject(new Error('STOPPED_BY_THROTTLE'));
		}

		promise = new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		});

		if (typeof then === "function") {
			promise = promise.then(then);
		}

		// Attempt to resolve
		resolver(...args);

		return promise;
	};

	throttle.cancel = () => resolver.cancel();

	return throttle;
}

/**
 * Waits a specific amount of time
 *
 * @param amount
 * @param payload
 */
function wait(amount, payload = {}) {
	return new Promise(resolve => {
		setTimeout(() => resolve(payload), amount);
	});
}

module.exports = {
	wait,
	debounce,
	createPromiseThrottle
};